import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/6_dogs-1/6_dogs-1"
 * Contains 6 texture(s)
 */
export class CardsFront6Dogs1Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/6_dogs-1/6_dogs-1';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'k-diamonds.png',
        'k-clubs.png',
        'j-spades.png',
        'j-hearts.png',
        'j-diamonds.png',
        'j-clubs.png'
    ] as const;
}
